module.exports = __webpack_public_path__ + "static/media/multiplysign.ffeceed6.gif";